import { render, staticRenderFns } from "./full-rule-list.vue?vue&type=template&id=e4b18d68&scoped=true&"
import script from "./full-rule-list.vue?vue&type=script&lang=ts&"
export * from "./full-rule-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b18d68",
  null
  
)

export default component.exports